module.exports = __webpack_public_path__ + "img/slide2.685e48f8.png";